// FUNCTIONALITY-115B — manager contact source context labels.
export type ManagerContactSurface =
  | "home"
  | "product"
  | "cart"
  | "checkout"
  | "success"
  | "payment"
  | "dropshipping"
  | "availability_request"
  | "referral"
  | "profile"
  | "bonuses"
  | "brands"
  | "brand"
  | "category"
  | "search"
  | "new";

export function managerSourceTitle(surface: string, lang: "ua" | "en" = "ua"): string {
  const mapUa: Record<string, string> = {
    home: "Головна сторінка",
    product: "Картка товару",
    cart: "Кошик",
    checkout: "Оформлення",
    success: "Підтвердження оплати",
    payment: "Підтвердження оплати",
    dropshipping: "Дропшипінг",
    availability_request: "Запит наявності",
    referral: "Реферальна програма",
    bonuses: "Реферальна програма",
    profile: "Про магазин",
    brands: "Бренди",
    brand: "Бренд",
    category: "Категорія",
    search: "Пошук",
    new: "Нові надходження",
  };
  const mapEn: Record<string, string> = {
    home: "Home",
    product: "Product card",
    cart: "Cart",
    checkout: "Checkout",
    success: "Payment confirmation",
    payment: "Payment confirmation",
    dropshipping: "Dropshipping",
    availability_request: "Availability request",
    referral: "Referral program",
    bonuses: "Referral program",
    profile: "About store",
    brands: "Brands",
    brand: "Brand",
    category: "Category",
    search: "Search",
    new: "New arrivals",
  };
  return (lang === "en" ? mapEn : mapUa)[surface] ?? surface;
}

export function buildManagerContactContext(input: {
  sourceSurface: string;
  sourceRoute?: string;
  locale: "ua" | "en";
  telegramUserId?: string | null;
  username?: string | null;
  phone?: string | null;
  productId?: string | null;
  sku?: string | null;
  productName?: string | null;
  category?: string | null;
  brand?: string | null;
  orderId?: string | null;
  paymentMethod?: string | null;
  referralCode?: string | null;
  selectedChannel?: string | null;
}): Record<string, unknown> {
  const baseUa = managerSourceTitle(input.sourceSurface, "ua");
  let detailUa = baseUa;
  if (input.sourceSurface === "product" && (input.productName || input.sku)) {
    detailUa = `Картка товару: ${input.productName ?? "—"}${input.sku ? `, SKU ${input.sku}` : ""}`;
  } else if (input.sourceSurface === "category" && input.category) {
    detailUa = `Категорія: ${input.category}`;
  } else if (input.sourceSurface === "brand" && input.brand) {
    detailUa = `Бренд: ${input.brand}`;
  }
  const sourceTitle = managerSourceTitle(input.sourceSurface, input.locale);
  return {
    source_surface: input.sourceSurface,
    source_route: input.sourceRoute ?? input.sourceSurface,
    source_title: sourceTitle,
    locale: input.locale,
    telegram_user_id: input.telegramUserId ?? null,
    username: input.username ?? null,
    phone: input.phone ?? null,
    product_id: input.productId ?? null,
    sku: input.sku ?? null,
    product_name: input.productName ?? null,
    category: input.category ?? null,
    brand: input.brand ?? null,
    order_id: input.orderId ?? null,
    payment_method: input.paymentMethod ?? null,
    referral_code: input.referralCode ?? null,
    selected_contact_channel: input.selectedChannel ?? null,
    timestamp: new Date().toISOString(),
    lead_type: input.sourceSurface === "dropshipping" ? "dropshipping" : null,
    // Shown only inside an explicit contact/payment packet (not as a browse-only ping).
    manager_header: `Контекст: ${detailUa}`,
  };
}
